module.exports = (__webpack_require__(76786))(2673);